import { defineMessages } from 'react-intl';

export default defineMessages({
    appName: {
        id: 'portal.name',
        defaultMessage: 'VendorEngage'
    },
    faq: {
        id: 'portal.index.FAQ',
        defaultMessage: 'FAQ'
    },
    logout: {
        id: 'header.links.Logout',
        defaultMessage: 'Logout'
    },
    preferences: {
        id: 'header.links.preferences',
        defaultMessage: 'Preferences'
    },
    
    bankDetails: {
        id: 'header.links.BankDetails',
        defaultMessage: 'Bank Details'
    }
});
